module.exports = __webpack_public_path__ + "media/images/emblems/GW-JU-Clos_du_Doubs-673638a701c0f1f3f42426be2ed42ec8.png";